<div class="fs-2 with-close" mat-dialog-title>
    Modification d'abonnement
    <i class="fa fa-close" (click)="onNoClick()" aria-hidden="true"></i>
</div>
<div mat-dialog-content class="pb-0">
    <p>
        Vous êtes sur le point de modifier votre forfait pour : <b>Abonnement {{ plan | titlecase }}</b><br/>
        <br/>
        Fréquence de paiement :
    </p>
    <div class="duration_choose mb-4" *ngIf="plan != 'pro'">
        <div class="duration {{ duration == 'month' ? 'active' : ''}} {{disable == 'month' ? 'disable' : ''}}" (click)="setDuration('month')">
            Mensuel
        </div>
        <div class="duration {{ duration == 'quarter' ? 'active' : ''}} {{disable == 'quarter' ? 'disable' : ''}}" (click)="setDuration('quarter')">
            Trimestriel
            <div class="discount">
                -10%
            </div>
        </div>
        <div class="duration {{ duration == 'year' ? 'active' : ''}} {{disable == 'year' ? 'disable' : ''}}" (click)="setDuration('year')">
            Annuel
            <div class="discount">
                -20%
            </div>
        </div>
    </div>
    <p *ngIf="loading" class="text-center mt-5 mb-5">
        <mat-spinner diameter="150" color="second" class="me-auto ms-auto"></mat-spinner>
    </p>

    <ng-container *ngIf="!loading && simulation.mode == 'up'">
        La modification de votre forfait sera immédiate après votre validation.<br/>
        <br/>
        <ng-container *ngIf="simulation.total > 0">
            Votre moyen de paiement

            <ng-container *ngIf="user.payment_method.type == 'sepa_debit'">
                prélèvement bancaire<br/>
            </ng-container>
            <ng-container *ngIf="user.payment_method.type == 'card'">
                {{ user.payment_method.type_detail | titlecase }} **** **** **** {{ user.payment_method.last_4 }}
            </ng-container>
            sera automatiquement prélevé de {{ simulation.total / 100|number:'1.1-2' }} €<br/>
            (Pour modifier votre moyen de paiement, <a (click)="updateCB()">cliquez ici</a>)
        </ng-container>
        <ng-container *ngIf="simulation.total < 0">
            Un avoir de {{ simulation.total / -100|number:'1.1-2' }} € sera crédité sur votre compte et se déduira automatiquement sur vos prochaines factures.
        </ng-container>
        <br/>
        <br/>
        <div class="recap">
            <b>Détails du paiement :</b>
            <table>
                <ng-container *ngFor="let line of simulation.lines">
                    <tr>
                        <td>{{ line.description }}</td>
                        <td class="text-end" width="100">{{ line.amount / 100|number:'1.2-2' }} €</td>
                    </tr>
                    <tr *ngIf="line.discount > 0">
                        <td>Remise</td>
                        <td class="text-end" width="100">-{{ line.discount / 100|number:'1.2-2' }} €</td>
<!--                        <th class="text-primary">Promo de rentrée</th>-->
<!--                        <th class="text-end text-primary" width="100">-{{ line.discount / 100|number:'1.2-2' }} €</th>-->
                    </tr>
                </ng-container>
                <tr class="border-top">
                    <th>
                        <ng-container *ngIf="simulation.total > simulation.amount_due">
                            Total
                        </ng-container>
                        <ng-container *ngIf="simulation.total <= simulation.amount_due">
                            Total dû aujourd’hui (TVA 20 % inclus)
                        </ng-container>
                    </th>
                    <th class="text-end">{{ simulation.total / 100|number:'1.2-2' }} €</th>
                </tr>
                <ng-container *ngIf="simulation.total > simulation.amount_due">
                    <tr>
                        <td>Crédit</td>
                        <td class="text-end">{{ (simulation.starting_balance -  simulation.ending_balance) / 100|number:'1.2-2' }} €</td>
                    </tr>
                    <tr class="border-top">
                        <th>Total dû aujourd’hui (TVA 20 % inclus)</th>
                        <th class="text-end">{{ (simulation.amount_due) / 100|number:'1.2-2' }} €</th>
                    </tr>
                </ng-container>
            </table>
        </div>
    </ng-container>
    <ng-container *ngIf="!loading && simulation.mode == 'down'">
        <p class="mt-4 mb-4">
            La modification de votre forfait sera effective dès votre prochain renouvellement, le {{ simulation.date }}
        </p>
    </ng-container>
    <ng-container *ngIf="!loading && (simulation.mode == 'error' || error == true)">
        <p class="text-red mt-1 mb-3">
            La tentative de modification a échoué, veuillez réessayer ou <a href="mailto:contact@lybox.fr">contactez-nous</a>.
        </p>
    </ng-container>
    <ng-container *ngIf="!loading && (simulation.mode == 'schedule' || error_schedule == true)">
        <p class="text-red mt-1 mb-3">
            Une modification est déjà en cours, <a href="mailto:contact@lybox.fr">contactez-nous</a> pour modifier votre abonnement.
        </p>
    </ng-container>
    <ng-container *ngIf="!loading && (simulation.mode == 'same')">
        <p class="mt-1 mb-3">
            Le plan est identique à votre abonnement actuel.
        </p>
    </ng-container>
</div>
<div mat-dialog-actions *ngIf="!loading && simulation.mode != 'error' && simulation.mode != 'schedule' && simulation.mode != 'same'">
    <button (click)="onNoClick()" type="reset" class="btn btn-outline">
        Annuler
    </button>
    <button (click)="onYesClick()" type="submit" class="btn btn-primary">
        <mat-spinner diameter="26" *ngIf="loading || loadingStripe"></mat-spinner>
        <ng-container *ngIf="!loading && !loadingStripe && simulation.mode == 'up'">Procéder au paiement</ng-container>
        <ng-container *ngIf="!loading && !loadingStripe && simulation.mode == 'down'">Valider la modification</ng-container>
    </button>
    <div class="clear"></div>
    <p class="fs-small text-center mt-3">
        En confirmant votre abonnement, vous autorisez LyBox à débiter votre compte pour les paiements à venir, conformément à ses conditions. Vous pouvez annuler votre abonnement à tout moment.<br/>
        En passant votre commande, vous acceptez nos <a target="_blank" href="https://www.lybox.fr/cgv">Conditions d'utilisation du service</a> et notre <a target="_blank" href="https://www.lybox.fr/charte">Politique de confidentialité</a>.
    </p>
</div>
